import { generateUserAgentHeader, urls } from 'Utilities/dataHelpers';
import mediator from 'Utilities/mediator';

export const handleConsent = async (
  patientId: string,
  action: string,
  osType: string,
  osVersion: string,
  app: string,
  appVersion: string,
  dataId: 'realWorldEvidence' | 'hipaa'
) => {
  const result = await mediator.request<ApiResponse<ConsentActionResponse>>('api:invoke', {
    method: 'PUT',
    url: `${urls.apiUrl}patients/${patientId}/consents`,
    headers: {
      'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
    },
    data: {
      id: dataId,
      action,
    },
  });

  if (result.data) {
    return result.data;
  }

  throw result;
};
